import React, { Component } from 'react';
import * as firebase from 'firebase';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';

import Auth from './CheckAuth'
import HOMENAV from './component/navBar/navbar'
import LOGIN from './component/auth/login'
import SIGNUP from './component/auth/signup'
import ConfirmationInstant from './component/auth/confirmation'
import LinkedWithPopup from './component/auth/linkedWithPopup'
import MyHome from './component/home/home'
import HOMENAVAFTERAUTH from './component/home/homeNav'
import SearchBox from './component/search/searchMage'
import QuizDetails from './component/details/quizDetail'
import JumbleDetails from './component/details/jumbleDetails'
import FAQ from './component/Faq/faq';
import EmailOption from './component/email/email';
import PlayOptions from './component/play/playOptions'
import KeyDisplay from './component/play/keyDisplay'
import EditProfile from './component/editProfile/editProfile'
import RESULTS from './component/played/played'
import ForgetPassword from './component/auth/forget'
import QuizQuestion from './component/quizquestion';
import ViewScore from './component/viewscore';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import injectTapEventPlugin from 'react-tap-event-plugin';

injectTapEventPlugin();

const config = {
    development: {
        apiKey: "AIzaSyCGPVCwF7LZJqdLWWwomdRLTfmRh0J94bY",
        authDomain: "mage-user.firebaseapp.com",
        databaseURL: "https://mage-user.firebaseio.com",
        projectId: "mage-user",
        storageBucket: "mage-user.appspot.com",
        messagingSenderId: "560340236455"
    },
    production: {
        apiKey: "AIzaSyDGUWXktyrlaagqf-ro1wqfu8ApyrNn7wc",
        authDomain: "mageproject-beadb.firebaseapp.com",
        databaseURL: "https://mageproject-beadb.firebaseio.com",
        projectId: "mageproject-beadb",
        storageBucket: "mageproject-beadb.appspot.com",
        messagingSenderId: "781554659331"

    }
};

let envoirnment = config.production;

firebase.initializeApp(envoirnment);


class Routers extends Component {
    render() {
        return (
            <MuiThemeProvider >
                <Router history={browserHistory}>
                    <Route path='/' component={HOMENAV}>
                        <IndexRoute component={LOGIN} />
                        <Route path='/sign-up' component={SIGNUP} />
                        <Route path='/log-in' component={Auth(LinkedWithPopup)} />
                        <Route path='/login-confirm' component={Auth(ConfirmationInstant)} />
                    </Route>
                    <Route component={Auth(HOMENAVAFTERAUTH)}>
                        <Route path='/home' component={Auth(MyHome)} />
                        <Route path='/find-mage' component={Auth(SearchBox)} />
                        <Route path='/detail-quiz' component={Auth(QuizDetails)} />
                        <Route path='/detail-jumble' component={Auth(JumbleDetails)} />
                        <Route path='/faq' component={Auth(FAQ)} />
                        <Route path='/feedback' component={Auth(EmailOption)} />
                        <Route path='/play-option' component={Auth(PlayOptions)} />
                        <Route path='/playingkey' component={Auth(KeyDisplay)} />
                        <Route path='/profile-edit' component={Auth(EditProfile)} />
                        <Route path='/my-result' component={Auth(RESULTS)} />
                        <Route path='/forget-password' component={Auth(ForgetPassword)} />
                        <Route path='/quizquestion' component={Auth(QuizQuestion)} />
                        <Route path='/viewscore' component={Auth(ViewScore)} />
                    </Route>
                    <Route path='/testing' component={EmailOption} />

                </Router>
            </MuiThemeProvider>
        );
    }
}

export default Routers;


// WEBPACK FOOTER //
// ./src/routers.jsx